import React, { Component } from 'react';
import './index.css';
import reportWebVitals from './reportWebVitals';
import NavigationPage from './Components/Pages/Navigation/NavigationPage';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

//import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
//import LocalizationProvider from '@mui/lab/LocalizationProvider';
import * as Actions from './Reducers/actions';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import ApiHelper from './Utils/API/apiHelper';
import { initializeApp } from 'firebase/app';
import { getAuth } from "firebase/auth";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import './App.css';
import ErrorBoundary from './Components/Shared/ErrorBoundary';
import ErrorHandlerService from './Services/ErrorHandlerService';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appSettings: null,
      ready: false,
    }
  }
  componentDidMount = () => {
    try {
      const firebaseConfig = {
        apiKey: "AIzaSyBfrMbCqucO7raJ3hclVNKetkOZXjbRgdQ",
        authDomain: "taplr-b96e9.firebaseapp.com",
        projectId: "taplr-b96e9",
        storageBucket: "taplr-b96e9.appspot.com",
        messagingSenderId: "228132134105",
        appId: "1:228132134105:web:b2786c6ed30a43f0c7f2c8",
        measurementId: "G-2CK1YFLXB3"
      };

      const app = initializeApp(firebaseConfig);
      firebase.initializeApp(firebaseConfig);
      firebase.auth().useDeviceLanguage();

      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('2fa-captcha', {
        size: 'invisible',
        callback: (response) => console.log('captcha solved!', response),
        'error-callback': (error) => {
          ErrorHandlerService.logError(error, { context: 'recaptcha' });
        }
      });

      const auth = getAuth(app);

      fetch("appSettings.json").then(
        function (res) {
          if (!res.ok) {
            throw new Error(`Failed to load app settings: ${res.status} ${res.statusText}`);
          }
          return res.json()
        }).then((data) => {
          ApiHelper.appSettings = data
          this.setState({ appSettings: data });
          this.setState({ ready: true });
        }).catch((err) => {
          console.error('Failed to load app settings:', err);
          ErrorHandlerService.handleApiError(err, 'Failed to load application settings');
          // Set a fallback state to prevent blank screen
          this.setState({ ready: true, appSettings: {} });
        })
    } catch (error) {
      console.error('Error during app initialization:', error);
      ErrorHandlerService.logError(error, { context: 'app_initialization' });
      // Ensure app still loads even if initialization fails
      this.setState({ ready: true, appSettings: {} });
    }
  }

  render() {
    return (
      <ErrorBoundary>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          {this.state.ready ? (
            <Router basename={`${process.env.PUBLIC_URL}`}>
              <NavigationPage {...this.props}></NavigationPage>
            </Router>
          ) : (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '100vh',
              backgroundColor: '#f8f9fa',
              fontFamily: 'Lato, sans-serif'
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                border: '4px solid #e3e3e3',
                borderTop: '4px solid #007bff',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                marginBottom: '20px'
              }}></div>
              <h2 style={{ color: '#495057', margin: '0 0 10px 0' }}>Loading Taplr...</h2>
              <p style={{ color: '#6c757d', margin: '0' }}>Please wait while we initialize the application</p>
              <style>
                {`
                  @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                  }
                `}
              </style>
            </div>
          )}
        </LocalizationProvider>

        <ToastContainer />
        <div id={"2fa-captcha"}></div>
      </ErrorBoundary>
    )
  }


}

reportWebVitals();

const mapStateToProps = state => ({
  listCopy: state.listCopy,
  externalApiCopy: state.externalApiCopy,
  projectCopy: state.projectCopy,
  Login: state.Login,
  activeFilters: state.activeFilters,
  settings: state.settings,
  Language: state.Language,
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
})

export default compose(connect(
  mapStateToProps,
  mapDispatchToProps
))(App);
